import Vue from 'vue'
// import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
import Tab from '@/views/config/tab.vue'

// 自定义列表
// import Customlist from '../views/customList/index'
import dashboard from '../views/dashboard/index'
import login from '../views/login/index' //登录
import AddProductConfigList from '../views/product-config-list/add'
import EditProductConfigList from '../views/product-config-list/edit'
// Vue.use(Router)
// 系统账号清单
import AddSystemAccount from '../views/systemAccount/add'
import EditSystemAccount from '../views/systemAccount/edit'

// 仓别配置
import Storehouse from '../views/storeHouse/index'
import SystemList from '../views/systemList/index'

// 系统门店修改
import SystemStoreEdit from '../views/systemStore/edit'
// 系统门店大仓修改
import SystemWarehouse from '../views/sysWarehouse/index'

// 可修改树状

import RoleSetting from '../views/roleSetting/index'
import MenuManager from '../views/menuManager/index'

// 系统SPA可销产品匹配
import Productmatchinglist from '../views/productMatchingList/index'
// 系统SAP开单客户代号匹配
import CustomerMatchEdit from '../views/sapKaidanKehuList/index'
// 旺旺 销售数据
import sales from '../views/sales/index'
// 权限管理
import Jurisdiction from '../views/jurisdiction/index'
// 用户管理
import userManagementList from '../views/userManagementList/index'
import AddUserManagemen from '../views/userManagementList/add'
// 组织管理
import AddOrganization from '../views/organizationManagement/add'
// 订单检查
import orderCheck from '../views/orderCheck/index'
import orderCreated from '../views/orderCheck/created'
import transport from '../views/orderCheck/transport'
import salesAudit from '../views/orderCheck/salesAudit'


/* Layout */
import Layout from '@/views/layout/Layout'
const routers = [
    { path: '/login', component: login, hidden: true },
    {
        path: '',
        component: Layout,
        hidden: true,
        redirect: 'dashboard',
        children: [{
            path: 'dashboard',
            component: dashboard,
            name: 'dashboard',
            meta: { title: 'dashboard', icon: 'dashboard', noCache: true }
        }, {
            path: '/tab/:path',
            component: Tab,
            name: 'tab'
        }]
    },
    // 用户管理-权限管理
    {
        path: '/jurisdiction',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        redirect: '/jurisdiction/index',
        children: [{
            path: '/jurisdiction/index',
            component: Jurisdiction,
            name: '权限管理',
            meta: {
                addName: '角色新增',
                detailName: '角色查看',
                editName: '角色编辑'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/product-config-list',
        component: Layout,
        hidden: true,
        children: [{
            path: 'add',
            component: AddProductConfigList,
            name: 'AddProductConfigList',
            meta: { title: '新增仓别产品配置清单' }
        }, {
            path: 'edit',
            component: AddProductConfigList,
            name: 'EditProductConfigList',
            meta: { title: '编辑仓别产品配置清单' }
        }]
    },
    // 仓别配置
    {
        path: '/storehouse',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        children: [{
            path: '/storehouse/index',
            component: Storehouse,
            name: '送货分公司仓别配置清单',
            meta: {
                addName: '送货分公司仓别配置清单新增',
                editName: '送货分公司仓别配置清单编辑'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/system-account',
        component: Layout,
        hidden: true,
        children: [{
            path: '/system-account/add',
            component: AddSystemAccount,
            name: 'AddSystemAccount',
            meta: { title: '送货分公司仓别产品配置清单' }
        }, {
            path: '/system-account/edit',
            component: EditSystemAccount,
            name: 'EditSystemAccount',
            meta: { title: '送货分公司仓别产品配置清单' }
        }]
    },
    {
        path: '/systemlist',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        children: [{
            path: '/systemlist/index',
            component: SystemList,
            name: '送货分公司仓别配置清单',
            meta: {
                addName: '送货分公司仓别配置清单新增',
                editName: '送货分公司仓别配置清单编辑'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    }, {
        path: '/systemStore',
        component: Layout,
        children: [{
            path: 'add',
            component: SystemStoreEdit,
            name: '新增系统门店清单',
            meta: {
                addName: '新增系统门店清单',
            },
            hidden: false,
            alwaysShow: true,
        }, {
            path: 'edit',
            component: SystemStoreEdit,
            name: '编辑系统门店清单',
            meta: {
                addName: '编辑系统门店清单',
            },
            hidden: false,
            alwaysShow: true,
        }]
    },
    {
        path: '/systemWarehouse ',
        component: Layout,
        children: [{
            path: '/systemWarehouse/index',
            component: SystemWarehouse,
            name: '编辑系统大仓清单',
            meta: {
                addName: '新增系统大仓清单',
            },
            hidden: false,
            alwaysShow: true,
        }]
    },
    {
        path: '/customerMatchEdit',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        redirect: 'customerMatchEdit/index',
        children: [{
            path: '/customerMatchEdit/index',
            component: CustomerMatchEdit,
            name: '新增开单客户代号匹配清单',
            meta: {
                addName: '新增开单客户代号匹配清单',
                editName: '编辑开单客户代号匹配清单'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/roleSetting',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        redirect: '/roleSetting/index',
        children: [{
            path: '/roleSetting/index',
            component: RoleSetting,
            name: '系统角色权限设置',
            meta: { title: '系统角色权限设置' },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    // 菜单管理
    {
        path: '/menu',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        redirect: '/menu/index',
        children: [{
            path: '/menu/index',
            component: MenuManager,
            name: '菜单管理',
            meta: { title: '菜单管理' },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/producmatchinglist',
        component: Layout,
        hidden: false,
        alwaysShow: false,
        children: [{
            path: '/producmatchinglist/index',
            component: Productmatchinglist,
            name: '可销产品匹配清单',
            meta: {
                addName: '新增可销产品匹配清单',
                editName: '编辑可销产品匹配清单'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/sales',
        component: Layout,
        hidden: false,
        redirect: '/sales/kayzsale',
        children: [{
            path: '/sales/kayzsale',
            component: sales,
            name: 'kayzsale',
            meta: { title: 'KA银座销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kayzstock',
            component: sales,
            name: 'kayzstock',
            meta: { title: 'KA银座库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kayzorder',
            component: sales,
            name: 'kayzorder',
            meta: { title: 'KA银座销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kasjlhsale',
            component: sales,
            name: 'kasjlhsale',
            meta: { title: 'KA世纪联华销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kasjlhstock',
            component: sales,
            name: 'kasjlhstock',
            meta: { title: 'KA世纪联华库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kasjlhorder',
            component: sales,
            name: 'kasjlhorder',
            meta: { title: 'KA世纪联华订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kashlhsale',
            component: sales,
            name: 'kashlhsale',
            meta: { title: 'KA上海联华销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kashlhstock',
            component: sales,
            name: 'kashlhstock',
            meta: { title: 'KA上海联华库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kashlhorder',
            component: sales,
            name: 'kashlhorder',
            meta: { title: 'KA上海联华订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kajlforder',
            component: sales,
            name: 'kajlforder',
            meta: { title: 'KA家乐福订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kabjhgsale',
            component: sales,
            name: 'kabjhgsale',
            meta: { title: 'KA北京华冠销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kabjhgstock',
            component: sales,
            name: 'kabjhgstock',
            meta: { title: 'KA北京华冠库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kabjhgorder',
            component: sales,
            name: 'kabjhgorder',
            meta: { title: 'KA北京华冠订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbbmorder',
            component: sales,
            name: 'kazbbmorder',
            meta: { title: 'KA中百便民订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbbmstock',
            component: sales,
            name: 'kazbbmstock',
            meta: { title: 'KA中百便民库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbbmsale',
            component: sales,
            name: 'kazbbmsale',
            meta: { title: 'KA中百便民销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbccorder',
            component: sales,
            name: 'kazbccorder',
            meta: { title: 'KA中百仓储订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbccstock',
            component: sales,
            name: 'kazbccstock',
            meta: { title: 'KA中百仓储库存表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kazbccsale',
            component: sales,
            name: 'kazbccsale',
            meta: { title: 'KA中百仓储销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kadrfsaleitem',
            component: sales,
            name: 'kadrfsaleitem',
            meta: { title: 'KA大润发品项销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kadrfsalestore',
            component: sales,
            name: 'kadrfsalestore',
            meta: { title: 'KA大润发销售门店表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kabbgorder',
            component: sales,
            name: 'kabbgorder',
            meta: { title: 'KA步步高订单表', icon: 'dashboard', noCache: true },
            hidden: true
        }, {
            path: '/sales/kabbgsale',
            component: sales,
            name: 'kabbgsale',
            meta: { title: 'KA步步高销售表', icon: 'dashboard', noCache: true },
            hidden: true
        }]
    },
    {
        path: '/userManagementList',
        component: Layout,
        hidden: true,
        redirect: '/userManagementList/index',
        children: [{
            path: '/userManagementList/index',
            component: userManagementList,
            name: 'userManagementList',
            meta: { title: '用户管理' }
        }, {
            path: '/userManagementList/add',
            component: AddUserManagemen,
            name: 'AddUserManagemen',
            meta: {
                addName: '新增用户',
                editName: '编辑用户'
            },
            //meta: { title: '新增用户'},
            hidden: true
        }]
    },
    {
        path: '/organizationManagement',
        component: Layout,
        hidden: true,
        redirect: '/organizationManagement/index',
        children: [{
            path: '/organizationManagement/index',
            component: userManagementList,
            name: 'organizationManagement',
            meta: { title: '组织管理', noCache: true }
        }, {
            path: '/organizationManagement/add',
            component: AddOrganization,
            name: 'AddOrganization',
            meta: {
                addName: '新增组织',
                editName: '编辑组织'
            },
            hidden: true,
            alwaysShow: false,
            props: true
        }]
    },
    {
        path: '/orderCheck',
        component: Layout,
        hidden: true,
        redirect: '/orderCheck/index',
        children: [{
            path: '/orderCheck/index',
            component: orderCheck,
            name: 'orderCheck',
            meta: { title: '订单检查', noCache: true }
        }, {
            path: '/orderCheck/created',
            component: orderCreated,
            name: 'orderCreated',
            meta: { title: '订单创建', noCache: true }
        }, {
            path: '/orderCheck/transport',
            component: transport,
            name: 'transport',
            meta: { title: '储运发运', noCache: true }
        },{
            path: '/orderCheck/salesAudit',
            component: salesAudit,
            name: 'salesAudit',
            meta: { title: '销管审核', noCache: true }
        }]
    },
]
export default routers


// WEBPACK FOOTER //
// ./src/_app/wwka/src/router/index.js